/**
 * Utility functions for managing recently viewed businesses in cookies
 */

const COOKIE_NAME = 'recentBusinesses';
const MAX_RECENT = 3;
const COOKIE_DAYS = 30;

/**
 * Get recent businesses from cookie
 * @returns {Array} Array of business objects
 */
export const getRecentBusinesses = () => {
  try {
    const cookie = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${COOKIE_NAME}=`));
    
    if (!cookie) return [];
    
    const value = cookie.split('=')[1];
    const decoded = decodeURIComponent(value);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Error reading recent businesses:', error);
    return [];
  }
};

/**
 * Add a business to recent businesses (max 3, most recent first)
 * @param {Object} business - Business object with id, customerId, business_name, etc.
 */
export const addRecentBusiness = (business) => {
  try {
    let recent = getRecentBusinesses();
    
    // Remove if already exists (to move to front)
    recent = recent.filter(b => !(b.id === business.id && b.customerId === business.customerId));
    
    // Add to front
    recent.unshift({
      id: business.id,
      customerId: business.customerId,
      business_name: business.business_name,
      description: business.description,
      category: business.category,
      rating: business.rating,
      total_bookings: business.total_bookings,
      branding: business.branding,
    });
    
    // Keep only max recent
    recent = recent.slice(0, MAX_RECENT);
    
    // Save to cookie
    const encoded = encodeURIComponent(JSON.stringify(recent));
    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_DAYS);
    
    document.cookie = `${COOKIE_NAME}=${encoded}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  } catch (error) {
    console.error('Error saving recent business:', error);
  }
};

/**
 * Clear all recent businesses
 */
export const clearRecentBusinesses = () => {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
